(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var saveButton = event.target.closest('#order-note [data-action="save-note"]');
    if (!saveButton) return;
    var note = saveButton.closest('.cart-recap__note');
    var toggle = note && note.querySelector('[aria-controls="order-note"]');
    if (toggle) toggle.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo1"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick
  $('.brands-responsive').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 4,
 	arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powr-image-slider"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick
  $('.brands-responsive').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 4,
 	arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-footer"] && !Shopify.designMode) return;
  try {
    
  function focusNewsletterFeedback() {
    var feedback = document.querySelector('.pro-footer [data-sn-newsletter-feedback]');
    if (!feedback || feedback.dataset.snFeedbackFocused === '1') return;
    feedback.dataset.snFeedbackFocused = '1';
    feedback.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusNewsletterFeedback);
  } else {
    focusNewsletterFeedback();
  }
  document.addEventListener('shopify:section:load', focusNewsletterFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-quote-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function focusQuoteFeedback() {
      var feedback = document.getElementById('quote-form-errors') || document.getElementById('quote-form-success');
      if (!feedback || feedback.dataset.snFocused === 'true') { return; }
      feedback.dataset.snFocused = 'true';
      feedback.focus();
    }
    if (document.readyState === 'complete') { focusQuoteFeedback(); }
    else { window.addEventListener('load', function () { requestAnimationFrame(focusQuoteFeedback); }, { once: true }); }
    document.addEventListener('shopify:section:load', focusQuoteFeedback);
  })();

  } catch(e) { console.error(e); }
})();
})();
